export default __webpack_public_path__ + "static/media/chat.85163377.svg";